/**
 * @description 页面逻辑基类
 * @author zhijie.huang
 * @date 2018/9/11
 */
import REQUEST_OPT from './request-opt.json'
import request from '../utils/request'
import errorCode from '../lang/zh-error'
import { Loading, Message } from 'uke-ui'

/**
 * 传入 auth构造方法，debug构造方法
 */
class LogicBase {
  constructor ({Auth, Debug}) {
    this.REQUEST_OPT = REQUEST_OPT
    this.ERROR_CODE = errorCode['errorCode']

    // 设置鉴权助手
    this.authHelper = Auth ? new Auth(this, this.ajax) : null

    // 设置调试助手
    this.debugHelper = Debug ? new Debug(this, this.ajax) : null

    // console.log('errorCode', this.ERROR_CODE);
  }

  // 暂不考虑多语言切换
  _getErrorText (res) {
    return this.ERROR_CODE[res.resultCode] ? this.ERROR_CODE[res.resultCode] : `${res.resultDesc}`
  }

  _handleErrorTips (text) {
    Message({
      message: text,
      type: 'error'
    })
  }

  _fixData (data) {
    const res = {}
    for (const key in data) {
      if (typeof data[key] === 'object') {
        res[key] = {}
        for (const kk in data[key]) {
          if (data[key][kk] !== '') res[key][kk] = data[key][kk]
        }
      } else {
        res[key] = data[key]
      }
    }
    return res
  }

  ajax (data, noTips = false, noLoading = false) {
    // const resData = this._fixData(data) // 18.11.2 黄志杰 不做处理（有些字段必传，但可以为空字符串）
    const resData = data
    if (resData.auth) {
      if (this.authHelper) {
        return this.authHelper.ajaxAuthor(resData, noTips, noLoading)
      } else {
        console.warn('LogicBase Error: authHelper is not defined!')
      }
      return
    }
    if (resData.test) {
      if (this.debugHelper) {
        return this.debugHelper.ajaxDebug(resData, noTips, noLoading)
      } else {
        console.warn('LogicBase Error: debugHelper is not defined!')
      }
      return
    }
    let viewName = null
    if (!noLoading) {
      viewName = document.getElementsByClassName('tabView')[0].firstChild.classList[0]
    }
    let loading = noLoading ? null : Loading.service({ target: `.${viewName}` })
    return new Promise((resolve, reject) => {
      if (resData.method.toLowerCase() === 'get') {
        resData.params = resData.data
        delete resData.data
      }

      request({ ...resData,
        headers: {
          'Time-Zone': 'GMT' + (-new Date().getTimezoneOffset() / 60),
          'Accept-Language': localStorage.getItem('language') || 'zh-CN'
        }
      }).then((res) => {
        if (res) {
          if (this.authHelper.checkSession(res)) {
            const errorText = this._getErrorText(res)
            if (!noTips) this._handleErrorTips(errorText)

            this.authHelper.handleSesstionTimeout()
          } else if (res.resultCode === '00000000') {
            if (resData.allData) {
              resolve(res)
            } else {
              resolve(res.data)
            }
          } else {
            const errorText = this._getErrorText(res)
            if (!noTips) this._handleErrorTips(errorText)
            reject(res)
          }
        }else{ //21.02.04 处理超时进不了任何回调的问题
          reject()
        }
      }).catch((err) => {
        reject(`${err.status} Error: ${err.statusText}`) // eslint-disable-line
      }).then(() => loading ? loading.close() : false)
    })
  }
}

export default LogicBase
